import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import moment from 'moment';
import { Subscription } from 'rxjs';
import { NavService } from '../../../../services/nav.service';
import { FapModalComponent } from '../../fap-modal/fap-modal.component';
import { GlobalRegistryService } from '../../../../../core/global-registry/global-registry.service';
import { SensorService } from '../../../../../core/services/api/sensor/sensor.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'fap-add-edit-scheduler',
  templateUrl: './fap-add-edit-scheduler.component.html',
  styleUrls: ['./fap-add-edit-scheduler.component.scss']
})
export class FapAddEditSchedulerComponent implements OnInit, OnChanges, OnDestroy{

  @Input() public scheduler = null;
  @Input() public schedulerId = null;
  @Output() public closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() public addScheduler: EventEmitter<any> = new EventEmitter<any>();
  @Output() public updateScheduler: EventEmitter<any> = new EventEmitter<any>();
  public addEditSchedulerForm: FormGroup;
  public schedulerTranslation = null;
  public langString: string = 'en';
  public subscriptions: Subscription[] = [];
  @ViewChild('addEditSchedulerTranslationPopup')
  public addEditSchedulerTranslationPopup: FapModalComponent;
  checkboxControls: { [key: string]: FormControl } = {};
  public minDate = null;
  public maxDate = null;
  public availableDays = [
      {id: '0', day: 'Sunday'},
      {id: '1', day: 'Monday'},
      {id: '2', day: 'Tuesday'},
      {id: '3', day: 'Wednesday'},
      {id: '4', day: 'Thursday'},
      {id: '5', day: 'Friday'},
      {id: '6', day: 'Saturday'},
  ];
  public availableMonths = [
    { id: '1', month: 'January' },
    { id: '2', month: 'February' },
    { id: '3', month: 'March' },
    { id: '4', month: 'April' },
    { id: '5', month: 'May' },
    { id: '6', month: 'June' },
    { id: '7', month: 'July' },
    { id: '8', month: 'August' },
    { id: '9', month: 'September' },
    { id: '10', month: 'October' },
    { id: '11', month: 'November' },
    { id: '12', month: 'December' }
];
  public days = [];
  public dates = [];
  public translation = null;
  public label:string;
  public modifiedScheduler = null;
  public month = [];
  public day = [];
  public dweek = [];
  public hour = [];
  @ViewChild('nameInput2', { static: true }) nameInput2: ElementRef;

  constructor(private navService: NavService, private formBuilder: FormBuilder, public globalRegistry: GlobalRegistryService, public sensorService: SensorService, public toastr: ToastrService) {
    for (let i = 1; i <= 31; i++) {
      this.dates.push(i.toString());
    }
  }

  ngOnInit(): void {
    this.langString = localStorage.getItem('language');
        this.subscriptions.push(
            this.navService.getCurrentLanguage.subscribe((lang) => {
                if (lang) {
                    this.langString = lang;
                }
            })
        );
        this.initAddEditSchedulerForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.hasOwnProperty('schedulerId') && this.schedulerId === 0) {
      this.scheduler = null;
      this.modifiedScheduler = null;
      this.addEditSchedulerForm.reset();
      this.addEditSchedulerForm.clearValidators();
      this.initAddEditSchedulerForm();
      this.dweek = [];
      this.availableDays.forEach((day) => {
        const control = new FormControl(this.dweek.includes(day.id));
        this.checkboxControls[day.id] = control;
      });
    }
    if (changes.hasOwnProperty('scheduler') && this.scheduler && this.schedulerId !== 0) {
        this.modifiedScheduler = { ...this.scheduler };
                                       
        if(this.modifiedScheduler.dweek) {
          if(this.modifiedScheduler.dweek === '*') {
            this.dweek = [];
            for (let i = 1; i <= 7; i++) {
              this.dweek.push(i.toString());
            }
            this.modifiedScheduler.dweek = this.dweek;
          } else {
            this.dweek = this.modifiedScheduler.dweek.split(',');
          }
        }

        if(this.modifiedScheduler.month) {
          if(this.modifiedScheduler.month === '*') {
            this.month = [];
            for (let i = 1; i <= 12; i++) {
              this.month.push(i.toString());
            }
            this.modifiedScheduler.month = this.month;
          } else {
            this.month = this.modifiedScheduler.month.split(',');
          }
        }

        if(this.modifiedScheduler.day) {
          if(this.modifiedScheduler.day === '*') {
            this.day = [];
            for (let i = 1; i <= 31; i++) {
              this.day.push(i.toString());
            }
            this.modifiedScheduler.day = this.day;
          } else {
            this.day = this.modifiedScheduler.day.split(',');
          }
        }

        if(this.modifiedScheduler.hour) {
          if(this.modifiedScheduler.hour === '*') {
            this.hour = [];
            for (let i = 1; i <= 24; i++) {
              this.hour.push(i.toString());
            }
            this.modifiedScheduler.hour = this.hour;
          } else {
            this.hour = this.modifiedScheduler.hour.split(',');
          }
        }

        this.initAddEditSchedulerForm();
        console.log(this.month);
        console.log(this.day);
        // this.addEditSchedulerForm.get('month').setValue(this.month);
        // this.addEditSchedulerForm.get('day').setValue(this.day);
    }
}

  getTranslation(translation) {
    const t = this.globalRegistry.systemData.translations.filter((trans) => {
        return trans.id === translation;
    });
    if(t[0]) {
      if(t[0][this.langString] === null || t[0][this.langString] === '') {
        return translation
      } else {
        return t[0][this.langString];
      }
    } else {
        return translation;
    }
  }

  maxValueChanged(ev) {
    console.log(ev);
  }

  minValueChanged(ev) {
    console.log(ev);
  }

  addEditTranslation(label: string, inputElement: any, translationTarget: any, popup: any, form: any) {
    this.label = label;
    const name = this[inputElement].nativeElement.value;
    const type: any = this.convertKeysToCamelCase(translationTarget);

    if (name === null || name === '' || type.nameT === null) {
        this.translation = null;
        popup.showModal();
    } else {
        for (const translation of this.globalRegistry.systemData.translations) {
            if (type && translation.id === type.nameT) {
                this.translation = translation;
                console.log(this.translation);
                popup.showModal();
                return;
            }
        }

        if (Object.keys(type).length === 0 && name) {
            const newTranslation = this[form].controls['name_t'].value;
            for (const translation of this.globalRegistry.systemData.translations) {
                if (translation.id === newTranslation) {
                    this.translation = translation;
                    console.log(this.translation);
                    popup.showModal();
                    return;
                }
            }
        }
    }
}        

convertKeysToCamelCase(obj) {
    const camelCaseObj = {};
    for (const key in obj) {
        const camelCaseKey = key.replace(/_([a-z])/g, (m, p1) =>
            p1.toUpperCase()
        );
        camelCaseObj[camelCaseKey] =
            obj[key] instanceof Object
                ? this.convertKeysToCamelCase(obj[key])
                : obj[key];
    }
    return camelCaseObj;
}

  onAddUpdateSchedulerTranslation(translation) {
    console.log(translation);
    this.schedulerTranslation = translation;
    this.addEditSchedulerForm.controls['name_t'].setValue(
        translation.id
    );
    this.addEditSchedulerForm.controls['name'].setValue(
        translation[this.langString]
    );
    this.schedulerTranslation = translation;
    this.addEditSchedulerTranslationPopup.hideModal();
  }

  initAddEditSchedulerForm() {
    this.availableDays.forEach((day) => {
        const control = new FormControl(this.dweek.includes(day.id));
        this.checkboxControls[day.id] = control;
      });
      console.log(this.checkboxControls);
    this.addEditSchedulerForm = this.formBuilder.group({
        name: [
            this.modifiedScheduler ? this.modifiedScheduler.name : '',
            Validators.required,
        ],
        name_t: [
            this.modifiedScheduler ? this.modifiedScheduler.name_t : '',
            Validators.required,
        ],
        // from: [
        //     this.modifiedScheduler ? this.modifiedScheduler.start : new Date(),
        //     Validators.required,
        // ],
        // to: [
        //     this.modifiedScheduler ? this.modifiedScheduler.end : new Date(),
        //     Validators.required,
        // ],
        dweek: new FormGroup(this.checkboxControls),
        hour: [
            this.modifiedScheduler ? this.hour : [],
            Validators.required,
        ],
        month: [
          this.modifiedScheduler ? this.month : [],
          Validators.required,
        ],
        day: [
          this.modifiedScheduler ? this.day : [],
          Validators.required,
        ],
        minute: [
            this.modifiedScheduler ? this.modifiedScheduler.minute : '',
            Validators.required,
        ],
        // duration: [
        //     this.modifiedScheduler ? this.modifiedScheduler.duration : '',
        //     Validators.required,
        // ]
    });
    if(this.modifiedScheduler && this.modifiedScheduler.name_t) {
        this.globalRegistry.systemData.translations.forEach(
            (translation) => {
                if (translation.id === this.modifiedScheduler.name_t) {
                    this.schedulerTranslation = translation;
                }
            }
        );
        this.addEditSchedulerForm.get('name').setValue(this.getTranslation(this.modifiedScheduler.name_t))
    }
  }

  submitScheduler() {
    let array = Object.values(this.checkboxControls);
    let dweek = [];
    const dayIndices = [0, 1, 2, 3, 4, 5, 6];
    array.forEach((day, index) => {
      if (day.value === true) {
        dweek.push(dayIndices[index]);
      }
    });
    const body = {
        name_t : this.schedulerTranslation ? this.schedulerTranslation.id : '',
        day: this.addEditSchedulerForm.value.day.toString(),
        hour: this.addEditSchedulerForm.value.hour.toString(),
        minute: this.addEditSchedulerForm.value.minute,
        dweek: dweek.toString(),
        month: this.addEditSchedulerForm.value.month.toString()
    }
    console.log(body);
    if(this.modifiedScheduler) {
        this.sensorService.updateScheduler(this.modifiedScheduler.id, body).subscribe((data) => {
            console.log(data);
            this.updateScheduler.emit(data.body.results);
            this.toastr.success('Scheduler updated successfully');
        }, (error) => {
          this.handleErrorMessage(error)
        })
    } else {
        this.sensorService.createScheduler(body).subscribe((data) => {
            console.log(data);
            this.addScheduler.emit(data.body.results);
            this.toastr.success('Scheduler created successfully');
        }, (error) => {
          this.handleErrorMessage(error)
        })
    }
  }

  handleErrorMessage(error) {
    return this.toastr.error('['+ error.error.results.code +'] ', error.error.results.error);
  }

  getCheckboxControl(dayId: string): FormControl {
    return this.checkboxControls[dayId];
  }

  changeDay(ev) {
    console.log(ev);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
}
